/*
 * @Author: Teemo Ding
 * @Date: 2021-10-21 16:04:01
 * @LastEditTime: 2021-10-21 16:17:02
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/types/common/miniProgram.ts
 */

export enum Status {
  Processing = 'Processing',
  Active = 'Active',
  Rejected = 'Rejected',
  Passed = 'Passed',
  Failed = 'Failed',
  Live = 'Live',
  Offline = 'Offline',
}

export enum Phase {
  Preview = 'Preview',
  Review = 'Review',
  Release = 'Release',
}

export interface ISalesChannelMiniProgram {
  uuid: string;
  storeUuid: string;
  salesChannelUuid: string;
  appID: string;
  accountName: string;
  profileImage: string;
  qrCode: string;
  hasError: boolean;
}

export interface ISalesChannelMiniProgramVersion {
  uuid: string;
  storeUuid: string;
  salesChannelUuid: string;
  version: string;
  submittedDate: string;
  statusDate: string;
  remarks: string;
  phase: Phase;
  status: Status;
  miniProgram: ISalesChannelMiniProgram;
}

export interface ISalesChannelMiniProgramSettingPage {
  miniProgram: ISalesChannelMiniProgram;
  preview: ISalesChannelMiniProgramVersion;
  review: ISalesChannelMiniProgramVersion;
  releases: ISalesChannelMiniProgramVersion[];
}
